import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { createBaseComponent } from 'intergalactic/core';
import useFlex from './useFlex';
function Flex(props, ref) {
  var _useFlex = useFlex(props, ref),
    _useFlex2 = _slicedToArray(_useFlex, 2),
    Tag = _useFlex2[0],
    flexProps = _useFlex2[1];
  return /*#__PURE__*/React.createElement(Tag, flexProps);
}
Flex.displayName = 'Flex';
export default createBaseComponent(Flex);
//# sourceMappingURL=index.js.map